import { createReducer } from 'modules/app-core/redux-utils'
import t from './actionTypes'

// initialState
const initialState = {
  tags: {},
}

export default createReducer(initialState, {
  [t.LOAD_TAGS]: (state, { id, tags }) => {
    const newTags = state.tags
    newTags[id] = {
      tags,
      isLoaded: true,
      isChanged: false,
      isUpdating: false,
      isEditing: false,
    }
    return {
      ...state,
      tags: newTags,
    }
  },
  [t.CHANGE_TAGS]: (state, { id, tags }) => {
    const newTags = state.tags
    let isAnyChanged = false
    const changedTags = []
    tags.forEach((tag) => {
      const isNewChanged = (tag.origState || false) !== (tag.IsActive || false)
      changedTags.push({ ...tag, isChanged: isNewChanged })
      isAnyChanged = isAnyChanged || isNewChanged
    })
    newTags[id] = {
      ...newTags[id],
      tags: changedTags,
      isChanged: isAnyChanged,
    }
    return {
      ...state,
      tags: newTags,
    }
  },
  [t.EDIT_TAGS]: (state, id) => {
    const newTags = state.tags
    const newTagsId = newTags[id] || { tags: [] }
    const tags = newTagsId.tags.map((tag) => ({
      ...tag,
      origState: tag.IsActive,
    }))
    newTags[id] = { ...tags[id], tags, isEditing: true }
    return {
      ...state,
      tags: newTags,
    }
  },
  [t.UPDATING_TAGS]: (state, id) => {
    const newTags = state.tags
    newTags[id] = { ...newTags[id], isEditing: false, isUpdating: true }
    return {
      ...state,
      tags: newTags,
    }
  },
  [t.UPDATING_TAG_DONE]: (state, tag) => {
    const newTags = state.tags[tag.ItemPublicKey]
    const indx = newTags.tags.findIndex((nTag) => nTag.name === tag.name)
    newTags.tags[indx] = {
      ...newTags.tags[indx],
      isChanged: false,
      isUpdated: true,
    }
    const isAllDone = newTags.tags.every((nTag) => nTag.isUpdated)
    const insertTags = isAllDone
      ? {
          ...newTags,
          isEditing: false,
          isUpdating: false,
          tags: newTags.tags.map(({ isChanged, isUpdated, ...nTag }) => nTag),
        }
      : newTags

    const tags = {
      ...state.tags,
      [tag.ItemPublicKey]: insertTags,
    }
    return {
      ...state,
      tags,
    }
  },
})
